export const programSection = {
  title: 'Темы форума',
  description: 'Основной пул вопросов для конференции',
  topics: [
    {
      title: 'Кейсы внедрения ИИ (отраслевые практики)',
      href: '/topic-ai-cases'
    },
    {
      title: 'От промптов к командам ИИ-агентов: как построить бизнес, который работает, пока вы спите',
      href: '/topic-ai-assistants'
    },
    {
      title: 'Улучшаем качество обслуживания в ритейле с помощью ML видеоаналитики',
      href: '/topic-ml-video-analytics'
    },
    {
      title: 'ИИ и рынок труда',
      href: '/topic-ai-labor-market'
    },
    {
      title: 'ИИ-трансформация. Почему это не про технологии, а про людей',
      href: '/topic-ai-transformation'
    },
    {
      title: 'Как ИИ увеличивает средний чек и снижает возвраты',
      href: '/topic-sales-conversion'
    },
    {
      title: 'Искусственный интеллект на службе инвестиционных фондов',
      href: '/topic-ai-investments'
    },
    {
      title: 'От экспериментов к системе: как крупный бизнес внедряет искусственный интеллект',
      href: '/topic-ai-enterprise'
    },
    {
      title: 'ИИ НЕ ЗАМЕНИТ МЕНЕДЖЕРОВ, но заменит слабое обучение: как бизнесу тренировать продажи, сервис и коммуникации на реальных сценариях',
      href: '/topic-ai-sales-training'
    }
  ]
};
